var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#00A0F3",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9083 38.1206C30.6363 38.1206 28.787 36.2713 28.787 33.9993C28.787 31.7273 30.6363 29.8779 32.9083 29.8779C35.1803 29.8779 37.0296 31.7273 37.0296 33.9993C37.0296 36.2713 35.1803 38.1206 32.9083 38.1206ZM35.2723 20.7246C31.271 20.3486 27.3576 21.7659 24.5403 24.6033C21.7216 27.4393 20.3336 31.3633 20.7336 35.3673C21.211 40.1299 24.2123 44.2766 28.5683 46.1873C30.311 46.9513 32.159 47.3259 33.9936 47.3259C36.8843 47.3259 39.7443 46.3939 42.1056 44.5859C42.691 44.1379 42.8016 43.3006 42.3536 42.7153C41.9056 42.1326 41.0696 42.0219 40.4843 42.4686C37.3936 44.8353 33.239 45.3206 29.639 43.7446C26.215 42.2433 23.763 38.8513 23.387 35.1006C23.067 31.8939 24.1763 28.7526 26.4323 26.4819C28.6856 24.2126 31.8216 23.0766 35.0256 23.3806C40.4323 23.8833 44.6656 28.6793 44.6656 34.2993V35.1993C44.6656 35.8233 44.4176 36.4046 43.9656 36.8366C43.515 37.2686 42.9176 37.4899 42.295 37.4633C41.103 37.4113 40.1323 36.2899 40.1323 34.9646V29.1993C40.1323 28.4619 39.5363 27.8659 38.799 27.8659C38.1203 27.8659 37.5843 28.3766 37.499 29.0326C36.2883 27.9126 34.683 27.2113 32.9083 27.2113C29.1656 27.2113 26.1203 30.2579 26.1203 33.9993C26.1203 37.7419 29.1656 40.7873 32.9083 40.7873C35.175 40.7873 37.1736 39.6593 38.407 37.9473C39.267 39.2006 40.631 40.0593 42.1776 40.1273C43.5283 40.1993 44.827 39.7033 45.8096 38.7633C46.7923 37.8233 47.3323 36.5579 47.3323 35.1993V34.2993C47.3323 27.3166 42.0363 21.3553 35.2723 20.7246Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtIcon);
export default __webpack_public_path__ + "static/media/AtIcon.2f09814c7c27b3ab1edc41a4fc8de58d.svg";
export { ForwardRef as ReactComponent };